import { useMutation } from '@tanstack/react-query';

import type { Estate } from '@/features/estates-property/api/estate';
import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type DeleteFloorLayoutsOptions = {
  mutationConfig?: MutationConfig<typeof deleteFloorLayouts>;
};

type DeleteFloorLayouts = {
  estateId: Estate['id'];
  layoutIds: string[];
};

const deleteFloorLayouts = ({ estateId, layoutIds }: DeleteFloorLayouts) => {
  return extractData(api.estates({ id: estateId }).layouts.batch.delete({ layoutIds }));
};

export const useDeleteFloorLayouts = ({ mutationConfig }: DeleteFloorLayoutsOptions = {}) => {
  return useMutation({ ...mutationConfig, mutationFn: deleteFloorLayouts });
};
